import React from 'react';
import cn from 'classnames';
import Grid from './Grid';
import { useMediaQuery } from 'react-responsive';

interface Props {
  className?: string;
}

const MethodIntroduce: React.FC<Props> = ({ className }) => {
  const isMobile = useMediaQuery({
    query: '(min-width:767px)',
  });
  return (
    <div
      className={cn(
        className,
        ' max-w-screen-lg text-center text-black min-h-screen mx-auto',
      )}>
      <Grid isMobile={isMobile} />
    </div>
  );
};

export default MethodIntroduce;
